import { compileTemplate, getTemplate } from "./TemplateV2";

const template = getTemplate();
const themeColor = "#8b5cf6";
const focusGlow = "0 0 0 4px rgba(139, 92, 246, 0.15)";

template.submitButton.button = {
  borderRadius: 12,
  padding: "18px 48px",
  fontSize: 16,
  fontWeight: 700,
  letterSpacing: "0.5px",
  textTransform: "uppercase",
  background: "#8b5cf6",
  boxShadow: "0 4px 14px rgba(139, 92, 246, 0.4)",
  transition: "all 0.3s ease",
  border: "none",
  "&:hover": {
    background: "#7c3aed",
    transform: "translateY(-2px)",
    boxShadow: "0 6px 20px rgba(139, 92, 246, 0.5)",
  },
  "&:active": {
    transform: "translateY(0px)",
    boxShadow: "0 2px 8px rgba(139, 92, 246, 0.3)",
  },
};

template.inputs = {
  input: {
    borderRadius: 12,
    border: "solid 2px #e2e8f0",
    padding: "16px 20px",
    fontSize: 15,
    backgroundColor: "#ffffff",
    transition: "all 0.2s ease",
    fontWeight: 400,
    color: "#1e293b",
    minHeight: 48,
    width: "100%",
    "&:focus": {
      border: `solid 2px ${themeColor}`,
      backgroundColor: "#ffffff",
      boxShadow: focusGlow,
      outline: "none",
    },
    "&::placeholder": {
      color: "#94a3b8",
      fontWeight: 400,
    },
    "&:hover": {
      border: "solid 2px #cbd5e1",
    },
    "@media (max-width: 768px)": {
      fontSize: 14,
      padding: "14px 18px",
      minHeight: 44,
    },
  },
  label: {
    fontSize: 14,
    fontWeight: 600,
    marginBottom: 8,
    color: "#334155",
    letterSpacing: "0.3px",
  },
  select: {
    borderRadius: 12,
    border: "solid 2px #e2e8f0",
    padding: "16px 20px",
    fontSize: 15,
    backgroundColor: "#ffffff",
    transition: "all 0.2s ease",
    cursor: "pointer",
    "&:focus": {
      border: `solid 2px ${themeColor}`,
      backgroundColor: "#ffffff",
      boxShadow: focusGlow,
      outline: "none",
    },
  },
};

template.formContainer = {
  form: {
    padding: "0",
  },
  bottomInfo: {
    padding: "32px 0 0 0",
  },
  checkbox: {
    accentColor: themeColor,
    width: 20,
    height: 20,
    cursor: "pointer",
    borderRadius: 4,
  },
};

export const templateStyles = compileTemplate(template);
export const defaultVals = {};
